import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkAccountForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsAccount = ({
  accountData,
  accountLinkDataChange,
  accountLinkDataValidate,
  accountLinkMetadata,
  editable,
  forceValidation,
  isSearchLoading,
  onSearch,
  searchStatus,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.account.title')}</h3>
    <LinkAccountForm
      account={accountData}
      editable={editable}
      forceValidation={forceValidation}
      isSearchLoading={isSearchLoading}
      linkMetadata={accountLinkMetadata}
      onChange={accountLinkDataChange}
      onSearch={onSearch}
      onValidate={accountLinkDataValidate}
      searchStatus={searchStatus}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsAccount;
